if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;
        const sectionsUrl = window.location.pathname;

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        let bundleItems = null;
        try {
          if (window.ShiftSyncVehicleFitment?.getBundleItems) {
            bundleItems = await window.ShiftSyncVehicleFitment.getBundleItems(
              formData.get('id'),
              formData.get('quantity') || 1
            );
          }
        } catch (e) {
          console.error(e);
        }

        const addToCart = (bodyIsJson, payload) => {
          const requestConfig = fetchConfig('javascript');
          requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          if (bodyIsJson) {
            requestConfig.headers['Content-Type'] = 'application/json';
            requestConfig.body = JSON.stringify(payload);
          } else {
            delete requestConfig.headers['Content-Type'];
            requestConfig.body = payload;
          }
          return fetch(`${routes.cart_add_url}`, requestConfig).then((response) => response.json());
        };

        let request;
        if (bundleItems && bundleItems.length > 1) {
          const body = { items: bundleItems };
          if (sections) {
            body.sections = sections.join(',');
            body.sections_url = sectionsUrl;
          }
          request = addToCart(true, body).then(async (response) => {
            if (response.status) {
              // Adapter may be sold out / unavailable — still add the knob alone.
              console.warn('[ShiftSync] Bundle add failed, retrying knob only:', response.description || response.message);
              if (this.cart && sections) {
                formData.append('sections', sections);
                formData.append('sections_url', sectionsUrl);
              }
              const solo = await addToCart(false, formData);
              if (!solo.status) {
                this.handleErrorMessage(
                  'Your shifter was added, but the adapter could not be added (it may be sold out).'
                );
              }
              return solo;
            }
            return response;
          });
        } else {
          if (this.cart && sections) {
            formData.append('sections', sections);
            formData.append('sections_url', sectionsUrl);
          }
          request = addToCart(false, formData);
        }

        request
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Always go to cart after a successful add
            window.location = window.routes.cart_url;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
